module.exports = __webpack_public_path__ + "img/placeholder/card-cta-no-link.jpg";